export default __webpack_public_path__ + "img-couple-sleeping.webp";